import Memorandum from "src/components/feature/Memorandum";

const MemorandumPage = () => {
  return <Memorandum />;
};

export default MemorandumPage;
